//@flow
import type {BannerContentPosition} from '../../../entities';

type Record<T> = {
  [key: string]: T,
};

export type BannerSize = {
  width: number,
  height: number,
};

export const BANNER_MEDIA_ASPECT_RATIO = {
  FLAT: {
    desktop: 80 / 30,
    mobile: 31 / 25,
  },
  TALL: {
    desktop: 16 / 7,
    mobile: 31 / 37,
  },
};

export const BANNER_MEDIA_SIZES = {
  FLAT: {
    desktop: {
      width: 1440,
      height: 540,
    },
    mobile: {
      width: 768,
      height: 620,
    },
  },
  TALL: {
    desktop: {
      width: 1440,
      height: 630,
    },
    mobile: {
      width: 768,
      height: 924,
    },
  },
};

export const BANNER_LAYOUTS: Record<BannerContentPosition> = {
  LEFT: 'LEFT',
  RIGHT: 'RIGHT',
  CENTER: 'CENTER',
  DOUBLE_CONTENT: 'DOUBLE_CONTENT',
};

export type BannerHomePage = {
  // layout: BannerLayout,
  images: {
    desktop: File,
    mobile: File,
  },
  title: string,
  subtitle: string,
  backgroundColor: string,
  textColor: string,
  buttonUrl: string,
  buttonConfig: {
    text: string,
    backgroundColor: string,
    textColor: string,
  },
};
